import { faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Accordion } from '../../flayr-components/Accordion/Accordion';
import { Flex } from '../../flayr-components/Flex/Flex';
import { ShowIf } from '../../flayr-components/ShowIf/ShowIf';

interface IFaqsProps {
  faqs: any[];
  collapsible?: boolean;
  questionTextSize?: string;
  answerTextSize?: string;
}

const Faqs: React.FC<React.PropsWithChildren<React.PropsWithChildren<IFaqsProps>>> = ({
  faqs,
  collapsible,
  questionTextSize = 'text-base md:text-xl',
  answerTextSize = 'md:text-lg',
}) => {
  return (
    <>
      {faqs.map((faq, key) => (
        <React.Fragment key={key}>
          <ShowIf
            condition={!collapsible}
            elseTemplate={
              <Accordion
                title={faq.q}
                iconClassName="text-black"
                titleClassName={questionTextSize}
              >
                <div className={`pb-3 text-gray-500 ${answerTextSize}`}>
                  {faq.a}
                </div>
              </Accordion>
            }
          >
            <Flex y="start" className="mb-8 lg:mb-10">
              <div>
                <div className={`${questionTextSize}`}>{faq.q}</div>
                <p
                  className={`mt-4 pl-5 pr-8 ${answerTextSize}`}
                  dangerouslySetInnerHTML={{ __html: faq.a }}
                />
              </div>
            </Flex>
          </ShowIf>
        </React.Fragment>
      ))}
    </>
  );
};
export default Faqs;
